module.exports = __webpack_public_path__ + "30cb7a39d6694eddd86c422056735d79.png";